import {
  authHeader,
  config,
  options,
  handleResponse,
  handleError
} from "../../common/helpers";

export const assetServices = {
  getAssetStatus,
  getAggregateData,
  getUsersList
};

function getAssetStatus(params) {
  const requestOptions = {
    method: "GET",
    headers: authHeader()
  };
  const url = options(config.apiUrl + "/dashboard/assets/severity");
  return fetch(url, requestOptions).then(handleResponse, handleError);
}

function getAggregateData(params) {
  const requestOptions = {
    method: "GET",
    headers: authHeader()
  };
  const url = options(
    config.apiUrl +
      "/dashboard/assets/severity/aggregation?granularity=" +
      params.granularity +
      "&startTime=" +
      params.startTime +
      "&endTime=" +
      params.endTime
  );
  return fetch(url, requestOptions).then(handleResponse, handleError);
}

function getUsersList(params) {
  const requestOptions = {
    method: "GET",
    headers: authHeader()
  };
  const serviceurl = options(
    config.apiUrl + "/organization/" + params + "/user"
  );
  const url = serviceurl;
  return fetch(url, requestOptions).then(handleResponse, handleError);
}
